// -- File upload limits -----------------------------------------------
export const MAXIMUM_FILE_SIZE_BYTES = 1073741824; // 1 GB

// -- Flow editor block node -------------------------------------------
// Every conversation block node renders at this fixed width (the live editor
// pins minW/maxW to it; the static card uses it as its width). Shared so the
// editor, the static card, and the auto-layout fallback all agree.
export const BLOCK_NODE_WIDTH = 340;

// -- Find in conversation ----------------------------------------------
// Search-match highlight colours: yellow (browser-find convention), not the
// theme's orange `warning` token, so a match reads as found rather than an
// alert.
export const FIND_HIGHLIGHT = {
  currentBg: 'yellow.300',
  currentFg: 'yellow.950',
  otherBg: 'yellow.100',
} as const;
